export default {
  /**
   * View 모드
   */
  VIEW_MODE: {
    MONITORING: 'monitoring', // 모니터링
    EDIT: 'edit', // 대시보드 편집
    TREE_EDIT: 'tree_edit', // 트리 편집
  },
  /**
   * 그리드 레이아웃 속성
   */
  GRID_LAYOUT_OPTION: {
    MIN_W: 1,
    MAX_W: 4,
    MIN_H: 1,
    MAX_H: 3,
    COL_NUM: 4,
    MARGIN: [12, 12],
    VERTICAL_COMPACT: true,
  },
  /**
   * 좌표 레이아웃 속성
   */
  COORD_LAYOUT_OPTION: {
    MIN_SCALE: 0.5,
    MAX_SCALE: 2,
    SCALE_STEP: 0.05,
    DEFAULT_WIDGET_H: 200,
    DEFAULT_WIDGET_W: 200,
    MIN_WIDGET_H: 2,
    MIN_WIDGET_W: 2,
    DEFAULT_W: 1920,
    DEFAULT_H: 1080,
  },
  /**
   * 위젯 기본 크기 [w, h]
   * @type {Object}
   */
  WIDGET_DEFAULT_SIZE: {
    ManagedObjectWidget: [64, 64],
    ChartWidget: [300, 200],
    EventGridWidget: [800, 200],
    TextWidget: [100, 20],
    IFrameWidget: [400, 400],
    SlideWidget: [400, 200],
    DecorationWidget: [100, 100],
    Topologymap2Widget: [400, 400],
    InterfaceOperationStatusWidget: [800, 200],
  },
  /**
   * 신규 위젯 임시 아이디
   * @type {String}
   */
  TEMP_WIDGET_ID: -1,
  /**
   * 이벤트 버스 종류
   * @type {Object}
   */
  EVENT_BUS: {
    DASHBOARD_LOAD: 'dashboard_load',
    DASHBOARD_GRP_SET: 'dashboard_group_set',
    DASHBOARD_SET: 'dashboard_set',
    DASHBOARD_SET_ON_EDIT: 'dashboard_set_on_edit',
    LAYOUT_UPDATE: 'layout_update',
    WIDGET_EDIT: 'widget_edit',
    WIDGET_COPY: 'widget_copy',
    WIDGET_DELETE: 'widget_delete',
    WIDGET_LOAD: 'widget_load',
    WIDGET_RESIZE: 'widget_resize',
    WIDGET_ADD_START: 'widget_add_start',
    WIDGET_ADD_END: 'widget_add_end',
    WIDGET_APPLY_SET: 'widget_apply_set',
    SQL_SETTING: 'sql_setting',
    TREE_LOAD: 'tree_load',
    CHANGE_CURRENT_VIEW_TYPE: 'change_current_view_type',
    DATABASE_SQL_LOAD: 'database_sql_load',
    GRID_FULL_SCREEN: 'full_screen',
    COORD_FULL_SCREEN: 'coord_full_screen',
    COORD_FULL_SCREEN_CLOSE: 'coord_full_screen_close',
    SHOW_DASHBOARD_DOWNLOAD_MENU: 'show_dashboard_download_menu',
    DASHBORD_IMAGE_DOWNLOAD: 'dashboard-image-download',
    SLIDESHOW_SET: 'slideshow_set',
    WIDGET_ACTIVE_CLEAR: 'widget_active_clear',
    WIDGET_ACTIVE_CHANGE: 'widget_active_change',
    DASHBOARD_SCALE_CHANGE: 'dashboard_scale_change',
    EVENT_LIST: 'event_list',
    OBJECT_SELECT: 'object_select',
    LOG_SELECT: 'log_select',
    CHANGE_SELECTED_INFO: 'change_selected_info',
    IMAGE_LOAD: 'image_load',
    IMAGE_SELECT_POPUP: 'image_select_popup',
    IMAGE_SETTING_POPUP: 'image_setting_popup',
    IMAGE_SELECT: 'image_select',
    SLIDESHOW_LOAD: 'slideshow_load',
    SLIDESHOW_EDIT: 'slideshow_edit',
    SLIDESHOW_START: 'slideshow_start',
    WIDGET_BIND_DATA: 'widget_bind_data',
    ACTIVE_TREE_TYPE_SET: 'active_tree_type_set',
    REFRESH_TIMER: 'refresh-timer',
  },
  /**
   * 위젯 속성
   */
  OPTIONS: {
    // 조회 구분
    SELECT_TYPE: {
      OBJ: 'OBJ',
      SQL: 'SQL',
      CPU: 'CPU',
      MEM: 'MEM',
      DISK: 'DISK',
      POWEROFF: 'POWEROFF',
      SNAPSHOT: 'SNAPSHOT',
      EXPIREDATE: 'EXPIREDATE',
      DELETEDATE: 'DELETEDATE',
      LOG_ALL: 'root',
      LOG_INDEX: 'dataindex',
      LOG_FILTER: 'filter',
      SSID: 'SSID',
      RADIOBAND: 'RADIOBAND',
      APGROUP: 'APGROUP',
    },
    // 데이터 시점 구분
    DATA_VIEWPOINT_TYPE: {
      NORMAL: 'normal', // 실시간(추이)
      PREDICT: 'predict', // 예측
    },
    // 데이터 구분
    SELECT_DATA_TYPE: {
      HIST: 'hist', // 이력
      STATUS: 'status', // 현황
    },
    // 조회 기준
    SELECT_OBJ_TYPE: {
      SINGLE: 'single',
      MULTI: 'multi',
    },
    ORDER_TERM: {
      CUR: 'CUR',
      DAY: 'DAY',
      WEEK: 'WEEK',
    },
    // 보기 형식
    VIEW_TYPE: {
      PIE: 'pie',
      COLUMN: 'column',
      EQUALIZER: 'equalizer',
      BAR: 'bar',
      LINE: 'line',
      AREA: 'area',
      TABLE: 'table',
      HEATMAP: 'heatmap',
      STACK: 'stack',
      PROGRESSBAR: 'progressbar',
      GAUGE: 'solidgauge',
    },
    // 차트 선 종류
    LINE_TYPE: {
      STRAIGHT: 'straight', // 꺾은 선
      SMOOTH: 'smooth', // 완만한 선
    },
    // 정렬
    ORDER: {
      TOP: 'top',
      BOTTOM: 'bottom',
    },
    TERM_TYPE: {
      D: 'day',
      W: 'week',
      M: 'month',
      Y: 'year',
    },
    TERM_TIME: {
      M15: '15m',
      M30: '30m',
      H1: '1h',
      H6: '6h',
      H12: '12h',
      H24: '24h',
    },
    SUMMARY_TYPE: {
      AVG: 'avg',
      MAX: 'max',
      MIN: 'min',
    },
    // 무선 네트쿼트 TOP 차트 사용
    SELECT_RSCTYPE: {
      CLIENT_COUNT: 'CLIENT_COUNT',
      TRAFFIC_BPS_IN: 'TRAFFIC_BPS_IN',
      TRAFFIC_BPS_OUT: 'TRAFFIC_BPS_OUT',
    },
    SELECT_BANDTYPE: {
      TOTAL: '_',
      GH24: '2.4 GHz',
      GH5: '5 GHz',
    },
    LIMIT: {
      L5: 5,
      L10: 10,
    },
  },
  SET_TYPE: {
    ADD: 'add',
    EDIT: 'edit',
    DELETE: 'delete',
  },

  // 대시보드 테마
  THEME: {
    WHITE: 'theme_white',
    BLACK: 'theme_black',
    GRADIENT: 'theme_gradient',
    PARTICLE: 'theme_particle',
  },
  TREE_CONST: {
    REF: 'treeRef',
    TYPE: {
      DEFAULT: 'check',
      CHECK: 'check',
      UNCHECK: 'uncheck',
    },
    SELECT_SCOPE: {
      DEFAULT: 'all',
      ALL: 'all',
      LEAF: 'leaf',
    },
    DATA_TYPE: {
      OBJ: 'obj',
      RSC: 'rsc',
    },
  },

  // 대시보드 다운로드 종류
  DOWNLOAD_TYPE: {
    FILE: 'file', // 템플릿 파일
    IMAGE: 'image', // 화면 캡쳐 이미지
  },
  TASK_NAME: {
    DASHBOARD_REFRESH: 'dashboard_refresh',
    FULL_SCREEN_REFRESH: 'full_screen_refresh',
    PROGRESS_REFRESH: 'progress_refresh',
  },

  // 대시보드 종류
  DASHBOARD_TYPE: {
    GRID: 'grid', // 그리드
    COORD: 'coord', // 좌표
  },

  // 위젯 정렬 종류
  WIDGET_ALIGN: {
    SEND_TO_TOP: 'SEND_TO_TOP',
    SEND_TO_BOTTOM: 'SEND_TO_BOTTOM',
    SEND_FORWARD: 'SEND_FORWARD',
    SEND_BACKWARD: 'SEND_BACKWARD',
    LEFT: 'LEFT',
    CENTER: 'CENTER',
    RIGHT: 'RIGHT',
    TOP: 'TOP',
    MIDDLE: 'MIDDLE',
    BOTTOM: 'BOTTOM',
    DISTRIBUTE_H: 'DISTRIBUTE_H',
    DISTRIBUTE_V: 'DISTRIBUTE_V',
  },

  // 위젯 설정 구분
  WIDGET_SET_TYPE: {
    BASE: 'base',
    DATA: 'data',
    VIEW: 'view',
  },

  // 로테이션 속성
  ROTATION: {
    TYPE: {
      NONE: 'none',
      VIEW: 'view',
      DATA: 'data',
    },
    MIN: 1,
    MAX: 7,
  },

  // 대시보드 배경 타입
  BACKGROUND_TYPE: {
    COLOR: 'C',
    IMAGE: 'I',
    ANIMATION: 'A',
    GRADIENT: 'G',
  },

  // 텍스트 정렬 종류
  TEXT_ALIGN: {
    LEFT: 'left',
    CENTER: 'center',
    RIGHT: 'right',
  },

  // 차트 애니메이션 지속시간
  CHART_ANIMATION_DURATION: 1500,

  // 편집 이력 타입
  HISTORY_TYPE: {
    ADD: 'add', // 추가
    REPLACE: 'replace', // 교체
    REMOVE: 'remove', // 삭제
    LOCATION: 'location', // 이동
    SIZE: 'size', // 리사이징
    ALIGN: 'align', // 정렬
    PROPERTY: 'property', // 속성
  },
  // 배경 애니메이션 타입
  BACKGROUND_ANIMATION_TYPE: {
    PARTICLE: 'particle',
    BUBBLE: 'bubble',
    STAR: 'star',
  },
  OBJDEFINE: {
    ND: 'NETDEVICE',
    WD: 'WIRELESS_DEVICE',
    NI: 'NETINTERFACE',
    FD: 'FMS_DEVICE',
    FS: 'FMS_SENSOR',
  },
  OBJTYPE: {
    AT: 'ALTIBASE',
    CU: 'CUBRID',
    DB2: 'DB2',
    IN: 'INFORMIX',
    IQ: 'SYBASEIQ',
    MS: 'MSSQL',
    MY: 'MYSQL',
    OR: 'ORACLE',
    PG: 'POSTGRESQL',
    SY: 'SYBASE',
    TB: 'TIBERO',
  },
  // 좌측 영역 설정 타입
  SIDE_SETTING_TYPE: {
    ELEMENT: 'element', // 위젯모음
    SETTING: 'setting', // 위젯설정
  },
  TASK: {
    WIDGET_LOAD_DATA: 'widget_load_data',
  },
  // 편집 > 위젯 선택 모드
  EDIT_SELECT_MODE: {
    SELECTION: 'selection', // 영역 선택 모드
    MOVE: 'move', // 이동 모드
  },
};



// WEBPACK FOOTER //
// ./src/constants/dashboard.js